<template>
  <div class="page">
    <div class="content" :class="status === 'fail' ? 'fail' : 'success'">
    </div>
    <div class="desc">
      <div>活动说明</div>
      <div>1.同一用户（相同账号、手机、设备等）仅可参与并获取一次奖励</div>
      <div>2.活动赠送的时长卡有效期为1个月，请在有效期内导入外部音频转写使用</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RewardResult',
  data () {
    return {
      status: ''
    }
  },
  created () {
    this.status = this.$route.query.status
  }
}
</script>

<style scoped lang="scss">
.page {
  padding-top: 500px;
  min-height: 100vh;
  background-color: #4178B9;
  background-image: url(~@/assets/img/rewardCollect/BG@2x.png);
  background-size: 750px 680px;
  background-repeat: no-repeat;
  .content {
    height: 376px;
    // padding: 540px 64px 0;
    text-align-last: left;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    &.fail {
      background-image: url(~@/assets/img/rewardCollect/fail@2x.png);
    }
    &.success {
      background-image: url(~@/assets/img/rewardCollect/success@2x.png);
    }
  }
  .desc {
    text-align: left;
    color: #fff;
    padding: 130px 64px 72px;
    div {
      font-size: 24px;
      font-family: PingFang SC;
      font-weight: 500;
      line-height: 36px;
    }
  }
}
</style>
